import { connect } from 'react-redux';
import {
  getCountdownUntil,
  getSliceAlignment,
  getSliceContent,
  getSliceIsDark,
  getSliceIsEdgeToEdge,
  getSlicePosition,
  hasActiveCountdown as hasActiveCountdownSelector,
  isWaitlistSubmissionFormVisible,
} from '../../selectors';
import { toogleWaitlistFormVisibility } from '../../actions';

const mapStateToProps = (state, { sliceId }) => {
  // TODO Code was copied from SliceCaption.js, refactor this
  const {
    countdown_title: countdownTitle,
    ...content
  } = getSliceContent(state, sliceId);
  const hasActiveCountdown = hasActiveCountdownSelector(state, sliceId);
  const title = (hasActiveCountdown && countdownTitle && countdownTitle.text) || content.title.text;

  return {
    title,
    image: getSliceContent(state, sliceId).hero_image,
    video: getSliceContent(state, sliceId).hero_video,
    hasActiveCountdown: hasActiveCountdownSelector(state, sliceId),
    isDark: getSliceIsDark(state, sliceId),
    alignment: getSliceAlignment(state, sliceId),
    position: getSlicePosition(state, sliceId),
    edgeToEdge: getSliceIsEdgeToEdge(state, sliceId),
    countdownUntil: getCountdownUntil(state, sliceId),
    formVisible: isWaitlistSubmissionFormVisible(state, sliceId),
    showSignupForm: getSliceContent(state, sliceId).show_signup_form === 'Yes',
  };
};

const mapDispatchToProps = dispatch => ({
  toggleVisibility: sliceId => {
    dispatch(toogleWaitlistFormVisibility(sliceId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps);
